import React from 'react';
import RightArrow from '../assets/images/RightArrow.svg';

export default () => {
  return <img src={RightArrow} alt="" />;
};
